import { merge } from 'lodash'

import alert from './alert'
import auth from './auth'
import mock from './mock'

const { defaults, resolvers, typeDefs } = merge(alert, auth, mock)

export { defaults, resolvers, typeDefs }
